import { useEffect } from "react";

// Blocks page-level pinch-zoom (iOS Safari ignores maximum-scale/user-scalable
// on the viewport meta tag for accessibility compliance, so the meta tag
// alone is NOT enough — see index.html). gesturestart/gesturechange are
// Safari-only pinch events; the touchmove fallback covers other engines.
// Anything inside a Mapbox/Leaflet map container is explicitly excluded so
// the map keeps its own pinch/pan/zoom gestures untouched.
const MAP_SELECTOR = '.mapboxgl-canvas-container, .leaflet-container, [data-testid="mapbox-map-view"]';

export function useBlockPinchZoom() {
  useEffect(() => {
    const isInsideMap = (target) => target?.closest?.(MAP_SELECTOR);

    const preventGesture = (e) => {
      if (isInsideMap(e.target)) return;
      e.preventDefault();
    };
    const preventMultiTouch = (e) => {
      if (e.touches.length > 1 && !isInsideMap(e.target)) e.preventDefault();
    };

    document.addEventListener("gesturestart", preventGesture);
    document.addEventListener("gesturechange", preventGesture);
    document.addEventListener("touchmove", preventMultiTouch, { passive: false });

    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("touchmove", preventMultiTouch);
    };
  }, []);
}
